<div class="loading-overlay" *ngIf="isLoading">
  <mat-progress-spinner
    mode="indeterminate"
    color="primary"
  ></mat-progress-spinner>
</div>

<div class="main" *ngIf="!isLoading">
  <div class="titulo">
    <div class="" style="display: flex; gap: 12px">
      <img src="../../../../../assets/svg/icons/detalhes-alimento.svg" alt="" />
      <p>Nutrientes</p>
    </div>
    <mat-icon style="cursor: pointer; color: #5f6368" (click)="onCancel()"
      >close</mat-icon
    >
  </div>

  <hr />

  <div class="conteudo">
    <div class="container-tabela">
      <table
        mat-table
        [dataSource]="nutrientesAlimento1"
        matSort
        #sort1="matSort"
        class="cis-default-table"
      >
        <ng-container matColumnDef="nutriente">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nutriente</th>
          <td mat-cell *matCellDef="let alimento">{{ alimento.nutriente }}</td>
        </ng-container>

        <ng-container matColumnDef="quantidade">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Quantidade</th>
          <td mat-cell *matCellDef="let alimento">{{ alimento.quantidade }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <!-- Mensagem quando não há dados -->
      <div
        *ngIf="!hasData1 && !hasData2"
        class="no-data"
      >
        Nenhum dado nutricional disponível.
      </div>
    </div>
  </div>
</div>